import { Box, GlobalStyles, styled } from '@mui/material';

export const GraphiQLContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  ['& .graphiql-container']: {
    backgroundColor: 'inherit',
    height: '100%'
  }
}));

export const GraphiQLGlobalStyles = () => (
  <GlobalStyles
    styles={{
      '.graphiql-tooltip': {
        zIndex: 'var(--mui-zIndex-tooltip)'
      },
      '.graphiql-dropdown-content': {
        zIndex: 'var(--mui-zIndex-tooltip)'
      }
    }}
  />
);
